<template>
  <div style="display: inline;">
    <yi_curd_table :name="$options.name" ref="yt" getUrl="/web/craft/basic/work/procedure/material/price/page" getKey="rows" :columns="columns" @selectionChange="selectionChange" :selectable="selectable">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialId"> </yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('shenhezhuangtai')">
            <el-select v-model="yt.conditions.status" clearable>
              <el-option :value="1" :label="$t('daishenhe')"></el-option>
              <el-option :value="2" :label="$t('shenhe')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button :loading="yt.loading" @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button type="primary" size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')">
          {{ $t('xinzeng') }}
        </el-button>
        <!--        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>-->

        <el-button v-if="utils.checkPower('web_base_process_price_check')" type="primary" size="mini" @click="review()" :disabled="selectIds.length == 0">
          {{ $t('shenhe') }}
        </el-button>

        <el-button v-if="utils.checkPower('web_base_process_update_log')" type="primary" size="mini" @click="yt.showEditDialog('xiugaijilu', null, '75%')">
          {{ $t('xiugaijilu') }}
        </el-button>

        <el-button v-if="utils.checkPower('web_base_process_material_month_price_page')" type="primary" size="mini" @click="yt.showEditDialog('meiyuedanjia', null, '75%')">
          {{ $t('meiyuedanjia') }}
        </el-button>

<!--        <el-button type="primary" v-if="utils.checkPower('web_report_export_chanpingdanjiashezhi_export')" size="mini" @click="exportExcel()">-->
<!--          {{ $t('daochu') }}-->
<!--        </el-button>-->
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" v-if="utils.checkPower('web_report_export_chanpingdanjiashezhi_export')" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
<!--        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>-->
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/craft/basic/work/procedure/material/price/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <!-- <yi_data_select :max="1" :type="'material2'" :ids.sync="yt.editObj.materialId"> </yi_data_select> -->
            <yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1" :ids.sync="yt.editObj.materialId"></yi_cross_select>
          </el-form-item>

          <el-form-item :label="$t('danjia(yuan)')" required>
            <el-input-number :precision="4" :min="0" v-model="yt.editObj.price"></el-input-number>
          </el-form-item>

          <el-form-item :label="$t('zhixingyuefen')" required>
            <el-date-picker v-model="yt.editObj.executionMonth" :clearable="false" value-format="yyyyMM" type="month" format="yyyyMM" :placeholder="$t('xuanzeyuefen')"> </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/craft/basic/work/procedure/material/price/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required class="noborder">
            <yi_data_select :max="1" :type="'material2'" :ids.sync="yt.editObj.materialId" disabled> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('danjia(yuan)')" required>
            <el-input-number :precision="4" :min="0" v-model="yt.editObj.price"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/craft/basic/work/procedure/material/price/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'xiugaijilu'">
        <div class="dialog-scroller">
          <material_price_update_log :workProcedureId="yt.conditions.workProcedureId"></material_price_update_log>
        </div>
      </template>

      <template v-if="yt.editObj.action == 'meiyuedanjia'">
        <div class="dialog-scroller">
          <material_price_mouth_price :workProcedureId="yt.conditions.workProcedureId"></material_price_mouth_price>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import XLSX from 'xlsx';
import product_price from '@@/pages/web/base/process/updata_log';
import Material_price_update_log from '@/yi-mes/web/pages/web/base/process/updata_log/index.vue';
import material_price_mouth_price from '@/yi-mes/web/pages/web/base/process/mouth_price/index.vue';
export default {
  components: { Material_price_update_log, material_price_mouth_price },
  comments: {
    product_price
  },
  name: 'web_base_process_product_price',
  data() {
    return {
      selectIds: [],
      columns: [
        {
          label: 'xuanze',
          type: 'selection',
          selectable: (row, index) => {
            return row.status === '1';
          },
          width: '50'
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name'
        },
        {
          label: 'gongxubianma',
          prop: 'workProcedure.code'
        },
        {
          label: 'gongxumingcheng',
          prop: 'workProcedure.desc'
        },
        {
          label: 'guige',
          prop: 'material.spec'
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient'
        },
        {
          label: 'yanse',
          prop: 'material.color'
        },
        {
          label: 'danjia(yuan)',
          prop: 'price'
        },
        {
          label: 'zhixingyuefen',
          prop: 'executionMonth'
        },
        {
          label: 'shenheren',
          prop: 'checkUser.nickname'
        },
        {
          label: 'shenhezhuangtai',
          prop: 'status',
          type: 'tag',
          width: 100,
          tags: {
            1: {
              color: '#E6A23C',
              text: this.$t('daishenhe')
            },
            2: {
              color: '#67C23A',
              text: this.$t('yishenhe')
            }
          }
        },
        {
          label: 'shenheshijian',
          prop: 'checkTime',
          type: 'time'
        },

        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          fixed: 'right',
          width: 150
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        workProcedureId: this.$attrs.workProcedure.id
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    review() {
      if (this.selectIds.length === 0) {
        this.$message({
          message: this.$t('qinggouxuanshuju'),
          type: 'error'
        });
        return;
      }
      this.http.post('web/craft/basic/work/procedure/material/price/review', { ids: this.selectIds }).then(res => {
        this.$message({
          message: this.$t('success'),
          type: 'success'
        });
        this.selectIds = [];
        this.yt.get(1);
      });
    },
    selectionChange(items) {
      this.selectIds = items.map(item => {
        return item.id;
      });
      if (this.selectIds.length > 0) {
        this.checkDisabled = false;
      } else {
        this.checkDisabled = true;
      }
    },
    beforeAdd(params, url) {
      params.workProcedureId = this.$attrs.workProcedure.id;
      return params;
    },

    exportExcel() {
      let params = this.yt.conditions;
      params.workProcedureId = this.$attrs.workProcedure.id;
      return this.http
        .get('/web/report/export/chanpingdanjiashezhi_export', { params })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');

        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
